export * from "./browserDecorator";
export * from "./events";
export { default as getUserData } from "./getUserData";
export { default as getUserDataForPCA } from "./getUserDataForPCA";
export { default as getExperimentsData } from "./getExperimentsData";
export { default as getCampaignData } from "./getCampaignData";
export { default as getDefaultViewData } from "./getDefaultViewData";
export { setClickThroughSourceToLocalStorage } from "./clickThroughSource";
export { initialiseIgluData } from "./initialiseIgluData";

declare global {
  interface Window {
    REAPackageVersions?: Record<string, string[]>;
  }
}
if (typeof window === "object") {
  window.REAPackageVersions = window.REAPackageVersions || {};
  window.REAPackageVersions["@realestate.com.au/iglu-data"] =
    window.REAPackageVersions["@realestate.com.au/iglu-data"] || [];
  window.REAPackageVersions["@realestate.com.au/iglu-data"].push(
    "__@realestate.com.au/iglu-data/version__",
  );
}
